import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import bankTransactionService from '../services'
import { TransactionQueryKeys } from '../../keys'
import showErrorToast from '@/common/utils/showErrorToast'

export function useMutationRematchSmsAutoLog() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({
			id,
			data,
		}: {
			id: string
			data: {
				depositTransactionId?: string
				playerId: string
				newAmount: number
				note?: string
			}
		}) => bankTransactionService.completeRematchSmsAutoLog(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [TransactionQueryKeys.SMS_AUTO_LOGS],
			})
			toast.success('Rematch สำเร็จ')
		},
		onError: (error) => showErrorToast(error),
	})
}
